<template>
  <v-container fluid class="discover-biblioteca">
    <v-skeleton-loader
      v-if="loading"
      dark
      type="image, image, image, list-item-avatar-three-line"
      class="discover-biblioteca__skeleton"
    />
    <div v-else-if="error" class="discover-biblioteca__state discover-biblioteca__state--error" role="alert">
      <p>Não foi possível carregar sua biblioteca.</p>
      <v-btn outlined color="#7a23bd" @click="load">Tentar novamente</v-btn>
    </div>
    <div v-else-if="!projects.length" class="discover-biblioteca__state">
      <p>Você ainda não salvou obras.</p>
      <router-link class="discover-biblioteca__action" :to="{ path: '/descobrir/categorias' }">
        Explorar categorias
      </router-link>
    </div>
    <template v-else>
      <div class="discover-biblioteca__results">
        <div class="discover-biblioteca__bar">
          <span class="discover-biblioteca__count">{{ projects.length }} {{ projects.length === 1 ? 'obra' : 'obras' }}</span>
        </div>
        <div class="discover-biblioteca__grid">
          <div v-for="project in projects" :key="project.id" class="discover-biblioteca__item">
            <HomeProjectCard :project="project" />
          </div>
        </div>
      </div>
    </template>
  </v-container>
</template>

<script>
import HomeProjectCard from "@/components/home/cards/HomeProjectCard.vue";
import { normalizeProjects } from "@/utils/homeProjectNormalizers";
import { getLibrary } from "@/server/workService";

import "@/styles/home-page/index.css";

export default {
  name: "DiscoverBiblioteca",
  components: {
    HomeProjectCard,
  },
  data() {
    return {
      projects: [],
      loading: true,
      error: false,
    };
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      this.error = false;
      try {
        const data = await getLibrary();
        this.projects = normalizeProjects(data?.data?.projects || data?.projects || []);
      } catch (error) {
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.discover-biblioteca {
  max-width: 1200px;
  margin: 0 auto;
  padding: 4px 0;
  color: #fff;
}

.discover-biblioteca__skeleton {
  max-width: 1200px;
  background: transparent;
}

.discover-biblioteca__state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 48px 16px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 16px;
  font-weight: 600;
  text-align: center;
}

.discover-biblioteca__state p {
  margin: 0;
}

.discover-biblioteca__state--error p {
  color: #f25568;
}

.discover-biblioteca__action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 22px;
  border-radius: 999px;
  background: rgb(78, 0, 141);
  color: #fff !important;
  font-weight: 700;
  font-size: 14px;
  text-decoration: none;
  transition: background 0.2s ease, transform 0.2s ease;
}

.discover-biblioteca__action:hover {
  background: #7a23bd;
  transform: translateY(-1px);
}

.discover-biblioteca__results {
  margin-top: 22px;
}

.discover-biblioteca__bar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.discover-biblioteca__count {
  color: rgba(183, 163, 203, 0.9);
  font-size: 12px;
  font-weight: 600;
}

.discover-biblioteca__grid {
  display: flex;
  flex-wrap: wrap;
}

.discover-biblioteca__item {
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  width: 50%;
  padding: 8px;
  cursor: pointer;
}

@media (min-width: 500px) {
  .discover-biblioteca__item {
    width: 33.33%;
  }
}

@media (min-width: 990px) {
  .discover-biblioteca__item {
    width: 20%;
  }
}
</style>